















































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { Getter, State, Action, Mutation } from 'vuex-class'
import { RootState } from '@/store/types'
import { EditorEntry } from '@/store/editor/types'
import Entry from '@/data/entry-model'

@Component({ name: 'v-vault-selector-item' })
export default class VVaultSelectorItem extends Vue {
    open: boolean = false

    @Prop({ type: String, default: '' })
    searchTerm!: string

    @Prop({ type: Object, default: null })
    vault!: Entry

    /**
     * Allow creation of new vaults
     */
    @Prop({ type: Boolean, default: false })
    allowCreate!: boolean

    @Prop({ type: Boolean, default: false })
    createNew!: boolean

    @Prop({ type: String, default: '' })
    createNewValue!: string

    @State((state: RootState) => state.editor.entry)
    entry!: EditorEntry

    get current(): boolean {
        return (this.vault && this.vault.id === this.entry.vault)
            || (!this.vault && !this.entry.vault && !this.createNew)
    }

    get children(): Entry[] {
        return this.vault.children
            .filter(child => child.id !== this.entry.id)
    }

    toggleOpen(): void {
        this.open = !this.open
    }

    update(id: string): void {
        this.$emit('update', id)
    }
}
